import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    rallyInfo: null,
    gameTasks: [],
    currentTaskId: null,
    game: {
        taskResults: [],
        totalPoints: 0,
        taskCount: 0,
        finishedTaskCount: 0,
    },
    gameStatus: null,
    currentTaskTimeLogs: null,
    tileCacheStatus: 'idle',
    tileCacheProgress: 0,
};
const rallyGameSlice = createSlice({
    name: 'rallyGame',
    initialState,
    reducers: {
        setRallyInfo: (state, action) => {
            state.rallyInfo = action.payload;
        },
        setGame: (state, action) => {
            state.game = action.payload;
            const completedTasks = state.game.taskResults.filter((task) => task.status === 'completed');
            if (state.game.taskCount === completedTasks.length) {
                state.gameStatus = 'can-be-completed';
            }
        },
        setGameTasks: (state, action) => {
            state.gameTasks = [...action.payload];
        },
        setCurrentTaskId: (state, action) => {
            state.currentTaskId = action.payload;
        },
        setTaskStatus: (state, action) => {
            state.game.taskResults = state.game.taskResults.map((task) => task.taskId === action.payload.taskUid ? { ...task, status: action.payload.status } : task);
            const completedTasks = state.game.taskResults.filter((task) => task.status === 'completed');
            if (state.game.taskCount === completedTasks.length) {
                state.gameStatus = 'can-be-completed';
            }
        },
        addTaskAnswer: (state, action) => {
            state.game.taskResults = state.game.taskResults.map((task) => task.taskId === action.payload.taskUid
                ? {
                    ...task,
                    playerAnswers: [...task.playerAnswers, action.payload.answer],
                }
                : task);
        },
        updateGameTotalPoints: (state, action) => {
            state.game.totalPoints += action.payload.lastEarnedPoints;
        },
        setGameStatus: (state, action) => {
            state.gameStatus = action.payload;
        },
        setCurrentTaskTimeLogs: (state, action) => {
            state.currentTaskTimeLogs = action.payload;
        },
        setTileCacheStatus: (state, action) => {
            state.tileCacheStatus = action.payload;
        },
        setTileCacheProgress: (state, action) => {
            state.tileCacheProgress = action.payload;
        },
    },
    selectors: {
        selectRallyInfo: (state) => state.rallyInfo,
        selectGame: (state) => state.game,
        selectGameTasks: (state) => state.gameTasks,
        selectGameTotalPoints: (state) => state.game.totalPoints,
        selectGameResults: (state) => state.game.taskResults,
        selectGameStatus: (state) => state.gameStatus,
        selectCurrentTaskId: (state) => state.currentTaskId,
        selectCurrentTaskInfo: (state) => state.gameTasks.find((task) => task.uid === state.currentTaskId),
        selectCurrentTaskResult: (state) => state.game.taskResults.find((task) => task.taskId === state.currentTaskId),
        selectCurrentTaskTimeLogs: (state) => state.currentTaskTimeLogs,
        selectTileCacheStatus: (state) => state.tileCacheStatus,
        selectTileCacheProgress: (state) => state.tileCacheProgress,
    },
});
export const { setRallyInfo, setGame, setGameTasks, setCurrentTaskId, setTaskStatus, addTaskAnswer, updateGameTotalPoints, setGameStatus, setCurrentTaskTimeLogs, setTileCacheStatus, setTileCacheProgress, } = rallyGameSlice.actions;
export default rallyGameSlice.reducer;
export const { selectRallyInfo, selectGame, selectGameTasks, selectCurrentTaskId, selectCurrentTaskInfo, selectCurrentTaskResult, selectGameResults, selectGameStatus, selectGameTotalPoints, selectCurrentTaskTimeLogs, selectTileCacheStatus, selectTileCacheProgress, } = rallyGameSlice.selectors;
